export const GET_ROOF_TYPES = "get_roof_types";
export const SET_ROOF_TYPES = "set_roof_types";
export const GET_ROOF_INFO = "get_roof_info";
export const SET_ROOF_INFO = "set_roof_info";
export const SET_ROOF_INTEGRATED = "set_roof_integrated";
